import {WlRadioButton} from "./radioButton.component";

export * from './radioButton.component';
export default WlRadioButton;

customElements.define('wl-radio-button', WlRadioButton);
